/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".tab-menu[_ngcontent-%COMP%] {\n  color: #C9E8E2;\n  background-color: transparent;\n  border: 1px solid #C9E8E2; }\n\n.tab-menu.active[_ngcontent-%COMP%] {\n  background-color: white;\n  color: var(--cust-blue); }\n\n.hover-grey[_ngcontent-%COMP%]:hover {\n  background-color: lightgrey; }"];
export { styles as styles };



// WEBPACK FOOTER //
// ./src/app/customer/customer.component.scss.shim.ngstyle.js.pre-build-optimizer.js